export default {"src":"/_next/static/media/coding_icon.b92e3b97.svg","height":132,"width":76,"blurWidth":0,"blurHeight":0};